import { render, staticRenderFns } from "./ControlSizing.vue?vue&type=template&id=53106d2f"
import script from "./ControlSizing.vue?vue&type=script&lang=js"
export * from "./ControlSizing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports